import React from 'react';
import './Loader.css';

const Loader = () => (
  <div className="loader-container">
    <div className="loader"></div>
    <span>Loading...</span>
  </div>
);

export default Loader;
